import { useEffect } from 'react';

const useDocumentHelper = title => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export default useDocumentHelper;
